import request from '@/utils/request'

let Ma_protocol_classificationApi = {

  /*协议分类列表*/
  list(data) {
    return request._post('/shop/plus.ma_protocol_classification.Index/index', data);
},
/*添加协议分类*/
add(data) {
    return request._post('/shop/plus.ma_protocol_classification.Index/add', data);
},
/*修改协议分类*/
edit(data) {
    return request._post('/shop/plus.ma_protocol_classification.Index/edit', data);
},
/*删除协议分类*/
del(data) {
    return request._post('/shop/plus.ma_protocol_classification.Index/del', data);
},
/*协议分类详情*/
detail(data) {
  return request._post('/shop/plus.ma_protocol_classification.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_protocol_classification.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_protocol_classification.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_protocol_classification.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_protocol_classification.Index/export', data);
    },
}
export default Ma_protocol_classificationApi;



// WEBPACK FOOTER //
// ./src/api/ma_protocol_classification.js